module.exports = __webpack_public_path__ + "img/JT-7-4-2-28-no08.ec668f87.jpg";